import { BasicCommand } from "../../../common/services/cqs/BasicCommand";
import { CommandType } from "../../../common/services/cqs/CommandType";
export class SetArbetsorderBatIdCommand extends BasicCommand<SetArbetsorderBatIdCommand> {
    get primaryKey() {
        return {
            arbetsorderId: this.arbetsorderId
        };
    }
    arbetsorderId: number;
    batId: string;
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "SetArbetsorderBatIdCommand";
    constructor(init: (instance: SetArbetsorderBatIdCommand) => void) {
        super("SetArbetsorderBatIdCommand", "Arbetsorder", CommandType.Replace);
        init(this);
    }
}
